import { useCallback } from 'react';
import { validateCEP, validateOptionalUrl } from '../../../../../insfrastructure/utils/form-validators';
import { removeFormatting } from '../utils/formatters';
import { MAX_TEXT_LENGTH, TEXT_LIMIT_FIELDS } from '../constants';
import { AddressData } from '../types';

export const useFieldValidation = () => {
  const validateField = useCallback((field: string, value: any): string | null => {
    if (field === 'company_phone') {
      const phoneValue = String(value || '').replace(/\D/g, '');
      if (!phoneValue || phoneValue.length < 10) {
        return 'Telefone é obrigatório e deve ter pelo menos 10 dígitos.';
      }
    }
    
    if (field === 'company_segment') {
      if (!value || value === '' || value === null || value === undefined) {
        return 'Segmento é obrigatório.';
      }
    }
    
    if (field === 'company_fantasy_name') {
      const fantasyNameValue = String(value || '').trim();
      if (!fantasyNameValue || fantasyNameValue === '') {
        return 'Nome fantasia é obrigatório.';
      }
    }

    if (field === 'company_website') {
      const urlError = validateOptionalUrl(value, 200);
      if (urlError) return urlError;
    }

    if (field === 'company_address') {
      const addressData = value as AddressData;
      const postcodeValue = addressData.postcode || '';
      const formattedPostcode = postcodeValue ? removeFormatting(String(postcodeValue)) : '';
      
      if (!formattedPostcode || formattedPostcode.length !== 8) {
        return 'CEP é obrigatório e deve ter 8 dígitos.';
      }
      
      const cepError = validateCEP(formattedPostcode);
      if (cepError !== '') {
        return cepError;
      }
      
      if (!addressData.address_number || String(addressData.address_number).trim() === '') {
        return 'Número do endereço é obrigatório.';
      }
    }

    return null;
  }, []);

  const formatValueForAPI = useCallback((field: string, value: any): any => {
    if (field === 'cpf' && value) {
      return removeFormatting(String(value));
    } else if (field === 'company_cnpj' && value) {
      return removeFormatting(String(value));
    } else if ((field === 'phone' || field === 'company_phone') && value) {
      return removeFormatting(String(value));
    } else if (field === 'company_segment' && value) {
      return parseInt(String(value));
    } else if (field === 'company_website') {
      return String(value || '').trim().substring(0, 200);
    } else if (TEXT_LIMIT_FIELDS.includes(field)) {
      return String(value || '').trim().substring(0, MAX_TEXT_LENGTH);
    } else if (field === 'company_address') {
      const addressData = value as AddressData;
      return {
        postcode: addressData.postcode ? removeFormatting(String(addressData.postcode)) : '',
        address_number: addressData.address_number || '',
        address_complement: addressData.address_complement || ''
      };
    }
    return String(value || '').trim();
  }, []);

  return { validateField, formatValueForAPI };
};

